import { createContext, useContext } from 'react';

export const NewsContext = createContext();

const useNews = () => useContext(NewsContext);

export default useNews;
